export const ui = {
  nav: {
    home: 'الرئيسية',
    experience: 'الخبرات',
    projects: 'المشاريع',
    services: 'الخدمات',
    certifications: 'الشهادات',
    resume: 'السيرة الذاتية',
    contact: 'تواصل',
    contactMe: 'لنتحدث',
    toggleMenu: 'فتح القائمة',
    logoSuffix: 'مهندس',
  },
  hero: {
    viewWork: 'تعرف على أعمالي',
    viewResume: 'السيرة الذاتية',
    contactMe: 'لنتحدث',
    yearsExperience: 'سنوات خبرة',
    since: 'منذ',
    careerStart: 'بداية المسيرة',
    addPhoto: '[أضف صورتك الشخصية]',
    orbit: {
      rag: 'RAG',
      mobile: 'Mobile',
      backend: 'Backend',
      products: 'Full-Stack Products',
    },
  },
  sections: {
    expertise: 'الخبرات',
    technologySkills: 'التقنيات والمهارات',
    technologySkillsSub: 'مجمّعة حسب المجال — من هندسة الذكاء الاصطناعي إلى الموبايل والخلفية وتطوير الويب.',
    careerProgression: 'مسار المسيرة المهنية',
    career: 'المسيرة',
    professionalJourney: 'رحلة مهنية',
    professionalJourneySub: 'رحلة بدأت في 2019 — من Java والموبايل إلى الذكاء الاصطناعي، خطوة بخطوة وبفهم أعمق لما يحتاجه الناس.',
    viewFullExperience: 'عرض الخبرة الكاملة',
    portfolio: 'معرض الأعمال',
    featuredProjects: 'مشاريع مميزة',
    featuredProjectsSub: 'مشاريع بنيتها بشغف — كل واحد منها يحمل قصة وحلّاً حقيقياً.',
    viewAllProjects: 'عرض جميع المشاريع',
    currentFocus: 'التركيز الحالي',
    aiEngineering: 'هندسة الذكاء الاصطناعي',
    aiEngineeringSub: 'أبني أنظمة ذكاء اصطناعي عملية — ليس لإبهار الآخرين بالتقنية، بل لخدمة الناس فعلاً.',
    viewAiEstimates: 'عرض تقديرات خدمات الذكاء الاصطناعي',
    productBuilder: 'باني منتجات',
    productsTitle: 'المنتجات والمشاريع المستقلة',
    productsSub: 'منتجات بقيت فيها شريكاً حقيقياً — من الفكرة الأولى حتى الإطلاق.',
    recognition: 'التقدير',
    achievementsTitle: 'الإنجازات والفعاليات',
    achievementsSub: 'مسابقات وفعاليات وتقدير لبناء تطبيقات مؤثرة.',
    credentials: 'الاعتمادات',
    certificationsTitle: 'الشهادات والإنجازات',
    certificationsSub: 'الشهادات المهنية، والإنجازات والمسابقات مع صور الفعاليات.',
    viewAllCertifications: 'عرض الكل',
    ctaTitle: 'هل لديك فكرة تريد إحياءها؟',
    ctaText: 'لا أبحث فقط عن مشاريع — أبحث عن قصص تستحق أن تُبنى. سواء كان لديك فكرة ناشئة، مشروع قائم، أو مجرد سؤال — يسعدني أن أسمع منك.',
    getInTouch: 'ابدأ محادثة',
    viewServices: 'عرض الخدمات',
  },
  aiFocus: {
    intro: 'اليوم أركز على هندسة الذكاء الاصطناعي — لكنني لم أصل هنا بالصدفة. سبع سنوات من بناء تطبيقات ومنتجات علّمتني أن التقنية الأهم هي التي تفهم السياق الإنساني قبل أن تكتب أول سطر كود.',
    localRag: {
      title: 'أنظمة RAG المحلية',
      description: 'بناء أنظمة توليد معزّزة بالاسترجاع تعمل محلياً، مع الحفاظ على خصوصية وأمان بيانات المؤسسة.',
    },
    aiAgents: {
      title: 'وكلاء الذكاء الاصطناعي',
      description: 'تصميم وكلاء أذكياء يؤتمتون سير العمل، ويتخذون قرارات، ويتكاملون مع أنظمة الأعمال الحالية.',
    },
    semanticLayers: {
      title: 'الطبقات الدلالية',
      description: 'إنشاء طبقات فهم دلالي تربط المعرفة المؤسسية بالاسترجاع والاستدلال المدعوم بالذكاء الاصطناعي.',
    },
    knowledgeRetrieval: {
      title: 'استرجاع المعرفة',
      description: 'ربط المعرفة المؤسسية بالذكاء الاصطناعي لتقديم إجابات عملية واعية بالسياق لحالات استخدام حقيقية.',
    },
  },
  experience: {
    current: 'حالياً',
    previously: 'سابقاً:',
    project: 'المشروع:',
    visitCompany: 'زيارة الشركة',
    completeProgression: 'مسار المسيرة المهنية الكامل',
    professionalExperience: 'الخبرة المهنية',
    professionalExperienceSub: 'من 2019 حتى اليوم — رحلة بنيت فيها خبرة حقيقية، مشروعاً تلو الآخر.',
  },
  projects: {
    allProjects: 'جميع المشاريع',
    allProjectsSub: 'تطبيقات موبايل، أنظمة ذكاء اصطناعي، منصات تجارة إلكترونية، وتطوير منتجات.',
    notFound: 'المشروع غير موجود',
    backToProjects: 'العودة إلى المشاريع',
    viewProject: 'عرض المشروع',
    googlePlay: 'Google Play',
    appStore: 'App Store',
    caseStudy: 'دراسة حالة',
    noProjects: 'لا توجد مشاريع في هذه الفئة.',
    viewProjectCard: 'عرض المشروع ←',
    addScreenshot: '[أضف لقطة المشروع]',
    addLogo: 'شعار',
    overview: 'نظرة عامة',
    myRole: 'دوري',
    problem: 'المشكلة',
    solution: 'الحل',
    architecture: 'البنية',
    companyInfo: 'معلومات الشركة',
    keyFeatures: 'الميزات الرئيسية',
    technologies: 'التقنيات',
    screenshots: 'لقطات الشاشة',
    estimatedCost: 'التكلفة التقديرية',
    addScreenshotPlaceholder: '[أضف لقطة]',
  },
  projectCategories: {
    all: 'الكل',
    AI: 'ذكاء اصطناعي',
    Mobile: 'موبايل',
    Web: 'ويب',
    Backend: 'خلفية',
    'E-commerce': 'تجارة إلكترونية',
    FinTech: 'تقنية مالية',
    Education: 'تعليم',
    Enterprise: 'مؤسسات',
    Marketplace: 'سوق',
  },
  services: {
    title: 'تقديرات المشاريع',
    subtitle: 'أمثلة لأنواع المشاريع مع وقت وتكلفة تقديرية.',
    disclaimer: 'هذه تقديرات وليست أسعاراً ثابتة. التسعير النهائي يعتمد على المتطلبات والتكاملات والتعقيد والجدول الزمني.',
    disclaimerNote: 'جميع الأسعار معروضة كـ نطاقات تقديرية ابتدائية. التسعير النهائي يعتمد على المتطلبات والتكاملات والتعقيد والجدول الزمني.',
    estimatedTime: 'الوقت التقديري',
    estimatedRange: 'النطاق التقديري الابتدائي',
    typicalFeatures: 'الميزات المعتادة',
    categories: {
      'Mobile Application': 'تطبيق موبايل',
      'Web Application': 'تطبيق ويب',
      Backend: 'خلفية',
      AI: 'ذكاء اصطناعي',
    },
    complexity: {
      Low: 'منخفض',
      Medium: 'متوسط',
      High: 'مرتفع',
      'Very High': 'مرتفع جداً',
    },
  },
  certifications: {
    achievementsTitle: 'الإنجازات والمسابقات',
    achievementsSub: 'مسابقات وفعاليات مع صور من كل مشاركة.',
    certificatesTitle: 'الشهادات',
    searchPlaceholder: 'ابحث في الشهادات...',
    noResults: 'لم يتم العثور على شهادات.',
    addCertificate: '[أضف الشهادة]',
    addCertificateImage: '[أضف صورة الشهادة]',
    issuer: 'الجهة المانحة:',
    date: 'التاريخ:',
    credentialId: 'رقم الاعتماد:',
    verify: 'التحقق من الاعتماد',
    close: 'إغلاق',
  },
  resume: {
    title: 'السيرة الذاتية المهنية',
    downloadPdf: 'تحميل السيرة الذاتية PDF',
    generatingPdf: 'جاري إنشاء PDF...',
    summary: 'الملخص المهني',
    experience: 'الخبرات',
    skills: 'المهارات',
    education: 'التعليم',
    projects: 'المشاريع',
    achievements: 'الشهادات والإنجازات',
    contact: 'التواصل',
    project: 'المشروع:',
    email: 'البريد الإلكتروني:',
    location: 'الموقع:',
    phone: 'الهاتف:',
    phoneJordan: 'الأردن',
    phoneSaudi: 'السaudi',
  },
  contact: {
    title: 'هل لديك فكرة؟ لنتحدث.',
    subtitle: 'أؤمن أن أفضل المشاريع تبدأ بمحادثة صادقة. أخبرني عن فكرتك، تحدّيك، أو حتى سؤالك — وسأرد بصدق، سواء كان بإمكاني المساعدة أم لا.',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    company: 'الشركة',
    projectType: 'نوع المشروع',
    budget: 'نطاق الميزانية',
    message: 'الرسالة',
    selectType: 'اختر النوع',
    selectBudget: 'اختر النطاق',
    send: 'إرسال الرسالة',
    thankYou: 'شكراً لك على تواصلك!',
    received: 'وصلت رسالتك — سأقرأها باهتمام وأرد عليك في أقرب وقت.',
    formNote: 'ملاحظة: اربط هذا النموذج بخدمة البريد أو الخلفية لاستقبال الرسائل.',
    contactInfo: 'معلومات التواصل',
    connect: 'تواصل',
    whatsappTitle: 'تواصل عبر واتساب',
    whatsappSub: 'اختر الرقم المناسب — ستفتح محادثة مع رسالة جاهزة يمكنك تعديلها قبل الإرسال.',
    whatsappJordan: 'واتساب — الأردن',
    whatsappSaudi: 'واتساب — السعودية',
    whatsappHint: 'الرسالة تتضمن اسمك ونوع استفسارك وكيف تعرفت على الموقع.',
    projectTypes: [
      'ذكاء اصطناعي / RAG',
      'تطبيق موبايل',
      'تطبيق ويب',
      'خلفية / API',
      'تجارة إلكترونية',
      'سوق',
      'أخرى',
    ],
    budgetRanges: [
      'أقل من 5,000 ريال',
      '5,000 – 15,000 ريال',
      '15,000 – 50,000 ريال',
      'أكثر من 50,000 ريال',
      'غير متأكد بعد',
    ],
  },
  footer: {
    navigation: 'التنقل',
    connect: 'تواصل',
    rights: 'جميع الحقوق محفوظة.',
    builtWith: '',
  },
  achievements: {
    learnMore: 'اعرف المزيد',
    addImage: '[أضف صورة',
  },
  seo: {
    defaultTitle: 'ماهر ملحم — مهندس ذكاء اصطناعي أول | أنظمة LLM خاصة',
    defaultDescription:
      'ماهر ملحم — مهندس ذكاء اصطناعي أول. أبني حلول AI جاهزة للإنتاج: LLM على GPU، n8n، Docker، NestJS/React، وتطبيقات ذكية.',
    experience: 'الخبرات — ماهر ملحم',
    projects: 'المشاريع — ماهر ملحم',
    services: 'الخدمات — ماهر ملحم',
    certifications: 'الشهادات — ماهر ملحم',
    resume: 'السيرة الذاتية — ماهر ملحم',
    contact: 'تواصل — ماهر ملحم',
  },
};
